/*!

=========================================================
* - v1.4.0
=========================================================

* Product Page: 
* Copyright 2020 Ahmed Abosaif
* Licensed under MIT Ahmed Abosaif

* Coded by Ahmed Abosaif

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link, Route } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,

  Badge
} from "reactstrap";

import routes from "routes.js";

import AuthService from "services/auth.service";
import NotificationAlert from "react-notification-alert";

import Timestamp from "react-timestamp";
import './styles.css';

//const ENDPOINT = "http://50.50.50.50:3000";


class Header extends React.Component {


  
  state = {
    isOpen: false,
    dropdownOpen: false,
    color: "transparent",
    notifications:[],
    numofnotif:0,

  };





  sidebarToggle = React.createRef();
  toggle = () => {
    if (this.state.isOpen) {
      this.setState({
        color: "transparent",
      });
    } else {
      this.setState({
        color: "white",
      });
    }
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };
  dropdownToggle = (e) => {
    if (this.state.dropdownOpen) {

      this.setState({
        dropdownOpen: !this.state.dropdownOpen,numofnotif:0
      });
    }
else {


  this.setState({
    dropdownOpen: !this.state.dropdownOpen,
  });


}






   

//01009518284 


  };



  getBrand = () => {
    var name;
    routes.map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
          return null;
        });
      } else {
        if (prop.redirect) {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        } else {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        }
      }
      return null;
    });
    return name;
  };
  openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    this.sidebarToggle.current.classList.toggle("toggled");
  };
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor = () => {
    if (window.innerWidth < 993 && this.state.isOpen) {
      this.setState({
        color: "white",
      });
    } else {
      this.setState({
        color: "transparent",
      });
    }
  };


  notify = (typee , msg) => {
    var options = {};
    options = {place: 'tc',message: (<div><div> {msg}</div></div>  ),type: typee,icon: "now-ui-icons ui-1_bell-53",autoDismiss: 7,}
    this.refs.notificationAlert.notificationAlert(options);
  }
  







  componentDidMount() {
    let user = AuthService.getCurrentUser().username;
    window.addEventListener("resize", this.updateColor.bind(this));



let data = {

};
data.logs = [{id:1, tktid:22089, msg:'Test Notification1', createdAt:'2022-02-23T08:00:00.000Z'},
{id:1, tktid:22098, msg:'Test Notification2', createdAt:'2022-02-23T08:00:00.000Z'},
{id:1, tktid:22068, msg:'Test Notification3', createdAt:'2022-02-23T08:00:00.000Z'},
{id:1, tktid:22067, msg:'Test Notification4', createdAt:'2022-02-23T08:00:00.000Z'}]

        // Add item to it
        // Set state
        this.setState({ notifications: data.logs , numofnotif:4});
        







  }

gotolink (tktid) {

  window.location.href = `/tkts/get/${tktid}`;

  
}

  componentDidUpdate(e) {


    
    if (
      window.innerWidth < 2048 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      this.sidebarToggle.current.classList.toggle("toggled");
    }
  }

logOut() {

  AuthService.logout();
}

  render() {
    const notifications =  this.state.notifications.map(notify =>(
      //<DropdownItem tag="p" onClick={alert('clicked')} key={notify.id} >Ticket#{notify.tktid}: {notify.msg}</DropdownItem>



<DropdownItem  className="ddownitem" key={notify.id} tag={Link} to={`/gettkt/${notify.tktid}`} style={{fontSize:12 , color:"black"}} className="ddowncont" ><div >
<strong>Ticket#{notify.tktid}:</strong> {notify.msg}<br/> <Timestamp style={{color:'green'}} date={notify.createdAt} relative   autoUpdate/></div></DropdownItem>


      
      )

)
    
    
    return (
      // add or remove classes depending if we are on full-screen-maps page or not
      <Navbar
        color={
          this.props.location.pathname.indexOf("full-screen-maps") !== -1
            ? "white"
            : this.state.color
        }
        expand="lg"
        className={
          this.props.location.pathname.indexOf("full-screen-maps") !== -1
            ? "navbar-absolute fixed-top"
            : "navbar-absolute fixed-top " +
              (this.state.color === "transparent" ? "navbar-transparent " : "")
        }
      >
        <Container fluid>

        <NotificationAlert ref="notificationAlert" />

          <div className="navbar-wrapper" style={{marginRight:"120px"}}>
            <div className="navbar-toggle">
              <button
                type="button"
                ref={this.sidebarToggle}
                className="navbar-toggler"
                onClick={() => this.openSidebar()}
              >
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </button>
            </div>
            <NavbarBrand href="/">{this.getBrand()}</NavbarBrand>
          </div>
          <NavbarToggler onClick={this.toggle}>
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </NavbarToggler>
          <Collapse
            isOpen={this.state.isOpen}
            navbar
            className="justify-content-end"
          >

            <Nav navbar>

            <Dropdown
                nav
                isOpen={this.state.dropdownOpen}
                toggle={(e) => this.dropdownToggle(e)}
                className="ddown"

              >
                <DropdownToggle caret nav>
                <i className="now-ui-icons ui-1_bell-53" />
                 <p>{this.state.numofnotif > 0 ? <Badge color="danger" id="testaoo" style={{fontSize:12}}>{this.state.numofnotif}</Badge> :null}</p>

                </DropdownToggle>
                <DropdownMenu right className="ddownmnu">
                {notifications}

                </DropdownMenu>
              </Dropdown>




              <NavItem>
                <Link to="#" className="nav-link">
                <p><i className="now-ui-icons users_single-02" />{AuthService.getCurrentUser().userfullname}</p>

                </Link>
              </NavItem>


              <NavItem>
                <Link to="/login" className="nav-link" onClick={this.logOut}>
                 Logout <i className="now-ui-icons sport_user-run" />
                </Link>
              </NavItem>






            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default Header;
